import { render } from "./ChangePaymentDateForm.vue?vue&type=template&id=53fe03e8"
import script from "./ChangePaymentDateForm.vue?vue&type=script&lang=js"
export * from "./ChangePaymentDateForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__